// extracted by mini-css-extract-plugin
module.exports = {"appPictureContainer":"boxcontainer_appPictureContainer__2jCXP","appPicture":"boxcontainer_appPicture__ZpuOz"};